import { render, staticRenderFns } from "./CreateFolderOther.vue?vue&type=template&id=d19b5168&scoped=true"
import script from "./CreateFolderOther.vue?vue&type=script&lang=js"
export * from "./CreateFolderOther.vue?vue&type=script&lang=js"
import style0 from "./CreateFolderOther.vue?vue&type=style&index=0&id=d19b5168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19b5168",
  null
  
)

export default component.exports